import { css } from "@emotion/react";

export const textStyle = css`
  font-size: 12px;
`;
